import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';
import { environment } from 'environments/environment.staging';

@Component({
  selector: 'app-user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.scss']
})
export class UserNotificationsComponent implements OnInit {
 public arrCountries: any[] = [];
  public countryId: any[] = [];
  
  public arrOrders: any[] = [];
  public basicSelectedOption: number = 10;

  public selectedStatus = [];
  public searchValue = "";
  public ColumnMode = ColumnMode;

  // private
  public tempData = [];
  public tempFilterData;
  public previousStatusFilter = "";
  public notifications :any 
  public userId:any

  @ViewChild(DatatableComponent) table: DatatableComponent;
  constructor(
    private apiService : ApisService,
    private activatedRoute : ActivatedRoute , 
    private loading : LoadingService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.userId = params['id'];
      
    })
    this.userNotifications()
  }

  filterUpdate(event: any) {
    const val = event.target.value.toLowerCase();
    this.tempData = this.arrOrders.filter((order) =>
      order.name.toLowerCase().includes(val)
    );
  }

  filterByStatus(event) {
    const filter = event ? event.value : "";
    this.previousStatusFilter = filter;
    this.tempFilterData = this.filterRows(filter);
    this.tempData = this.tempFilterData;
  }

  filterRows(statusFilter): any[] {
    if (statusFilter === "") {
      return this.arrOrders;
    } else if (statusFilter === "Other") {
      const mainStatuses = [
        "not set",
        "return",
        "delivered",
        "failed delivery",
      ];
      return this.arrOrders.filter(
        (order) => !mainStatuses.includes(order.delivery_status.toLowerCase())
      );
    }
    return this.arrOrders.filter(
      (order) =>
        order.delivery_status.toLowerCase() === statusFilter.toLowerCase()
    );
  }

  
  /*----------  Notifications  ----------*/
  userNotifications() {
    this.loading.show()
    this.apiService.userNotifications(this.userId).subscribe({
      next: (res) => {
        this.loading.hide() 
        this.notifications = res.data.items
        
      },
      error(err) {
        this.loading.hide()
        console.log("Error in fetching", err)
      },
    })
  }

    getFirstImage(postItem): string {
      return postItem?.media
        ? environment.mediaUrl + "/" + postItem.media.url
        : // : "assets/images/logo/logo1.svg";
          "assets/images/goalngo/profile.svg";
    }
  

}
